import { isAxiosError } from "axios";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import { useRifaStore } from "../../store/rifaStore";
import { useGeneralAppStore } from "../../store/generalAppStore";

const { setSolicitud, setPrecio } = useRifaStore.getState();
const { handlerModal } = useGeneralAppStore.getState();

export const sendRespuesta = async (
  vari,
  setVari,
  data,
  setErrorPrecio,
  reset,
  handlerModal,
  setLoading,
  setLinkPago
) => {
  setLoading(true);
  // setVari({ ...vari, loading: true });
  let response = await axios().post("solicitud", data);
  if (!isAxiosError(response)) {
    // console.log(response.status)
    // setVari({...vari, status:response.status})
    const { data, error } = response.data;

    if (data && !error) {
      setSolicitud(data);
      setVari({ ...vari, /* loading: false, */ data: data, status: response.status });
      setLoading(false);
      if (data.includes("Ha habido un error al momento de generar el recibo")) {
        toast.error(`Ha habido un error al momento de generar el recibo, por favor intente mas tarde.`, toastOptions);
      } else {
        toast.success("Solicitud Enviada", toastOptions);
        setLinkPago(data);
        const newWindow = window.open(data, "_blank");
        if (newWindow) {
          handlerModal({ modal: false, modalName: "datos-solicitante" });
          setLinkPago(null);
          reset();
        }
      }
    }
    if (error && !data) {
      setPrecio(0);

      if (error?.precio) {
        setErrorPrecio(error.precio);
        // toast.error(error.precio, toastOptions);
      } else if (error.includes("Usuario perteneciente a planta po")) {
        window.location.hash = "acceso_denegado_muni";
      } else {
        toast.error("Hubo un error en el sistema", toastOptions);
      }
      handlerModal({ modal: false, modalName: "datos-solicitante" });
      setVari({ ...vari, /* loading: false, */ error: error, status: response.status });
      setLoading(false);
    }
  } else {
    setVari({ ...vari, /* loading: false, */ error: "Hubo un error inesperado", status: 500 });
    setLoading(false);
  }
};

export const getPrecio = async (vari, setVari, data) => {
  setVari({ ...vari, loading: true });
  let response = await axios().get("rifa_precio");
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setPrecio(data);
      setVari({ ...vari, loading: false, data: data });
      // toast.success("Solicitud Enviada", toastOptions);
    }
    if (error && !data) {
      setVari({ ...vari, loading: false, error: error });
      if (error != "Servicio no disponible") {
        toast.error("Ha habido un error al enviar la solicitud", toastOptions);
      }
    }
  } else {
    setVari({ ...vari, loading: false, error: "Hubo un error inesperado" });
  }
};

export const getValidacion = async (payload, setLoading, setPrecio, precio) => {
  setLoading(true);
  try {
    const response = await axios().post("validacion", { ...payload, precio: precio });
    if (!isAxiosError(response.data)) {
      const { data, error } = response.data;
      if (data && !error) {
        handlerModal({ modal: true, modalName: "datos-solicitante" });
      }
      if (!data && error) {
        if (error.precio) {
          toast.error("Se cambio el precio de la rifa, vuelva a intentarlo", toastOptions);
          setPrecio(0);
        } else if (error.includes("Usuario perteneciente a planta")) {
          window.location.hash = "acceso_denegado_muni";
        } else {
          toast.error("Hubo un error en la consulta", toastOptions);
        }
      }
    }

    // toast.error("Hubo un error en la consulta", toastOptions);
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    setLoading(false);
  }
};
